import React, { useState, useContext, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";

import MLRPDFHeader from "./MLRPDFHeader";
import { geteDetailByID, getTrackChangesDetails, PublishHTMLAndPDF, PublishHTMLAndPDFBinder, PublishHTMLAndPDFbinder } from "../../services/apis";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import CircularProgressBar from "../../utils/CircularProgressBar";
import CustomModal from "../../components/CustomModal";
import ApprovedTemplateModal from "./ApprovedTemplateModal";
import { click } from "@testing-library/user-event/dist/click";
import { PublishToVeeva } from "../../services/apis";
import ModuleStepper from "../ContentModules/ModuleWindow/ModuleStepper";
import { Nav, Tab } from "react-bootstrap";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import { useSearchParams } from "react-router-dom";

// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/cjs/Page/AnnotationLayer.css";

export default function MLRPDDF({
  deckData,
  setExportFormats,
  pdfURL,
  setOpenMLRPDF,
}) {
  const [numPages, setNumPages] = useState(null);
  const [pdfWidth, setpdfWidth] = useState(800);
  const [MLR, setMLR] = useState("-");
  const pdfDisplay = useRef();
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showApprovedModal, setShowApprovedModal] = useState(false);
  const [clickOnSubmit, setClickOnSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageLength, setPageLength] = useState(9);
  const [defaultNumber, setDefaultName] = useState(0);
  const [mlrData, setMlrData] = useState(null);
  const [previewData, setPreviewData] = useState();
  const [tempType, setTempType] = useState(1);
  const [activeTab, setActiveTab] = useState("first");
  const [pdfImage, setPdfImage] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [popupSelectedIndex, setPopUpSelectedIndex] = useState(null);
  const inputRefs = useRef({});
  const inputPopupRefs = useRef({});
  const [searchParams] = useSearchParams();
  const minorVersion = searchParams?.get("minorVersion");

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  } //
  pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
  //  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  useEffect(() => {
    setPreviewLoading(true);
    setpdfWidth(pdfDisplay?.current?.getBoundingClientRect()?.width - 48);
    // setpdfWidth(pdfDisplay.current.getBoundingClientRect().width - (-40));
    getDetailsById();
  }, []);

  useEffect(() => {
    getTrackChanges();
  }, [activeTab]);

  const getDetailsById = () => {
    geteDetailByID(deckData?.id, (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
      } else {
        if (response.data.veevaMetadata.length > 0)
          setMLR(response.data.veevaMetadata[0]?.pdfNo);
        setMlrData(response.data.veevaMetadata[0]);
        setPreviewLoading(false);
        setPreviewData(response.data);
      }
    });
  }

  const handleApprovedtemplateModal = () => {
    setShowApprovedModal(true);
  };
  const closeApprovedTemplateModal = () => {
    setShowApprovedModal(false);
  };
  const submitMLR = () => {
    setLoading(true);
    PublishToVeeva(
      deckData?.id,
      { pdfUrl: deckData.pdfURL, country: deckData.country, html: generateHTML()},
      (response, err, errorCode) => {
        if(err?.code === "ERR_NETWORK") {
          showErrorToast('Network not found. Pl reconnect to continue');
          setLoading(false);
        } else if (err) {
          setLoading(false);
          showErrorToast('MLR Submission failed. Pl try again');
        } else {
          setLoading(false);
          const data = response.data.response;
          setMLR(data.docNumber);
          setMlrData(data);
          getDetailsById();
          showSuccessToast('Publish is in progress. An email notification will be sent to you once the PDF has been published.');
          setShowApprovedModal(false);
        }
      }
    );
  };
  // console.log(mlrData, 'mlt', minorVersion);
  const pageListLength = Array.from(new Array(numPages));
  
  const publishHtml = (deckId) => {
    setLoading(true);
    PublishHTMLAndPDF(
      deckId,
      (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          console.log(err);
        } else {
          setLoading(false);
          showSuccessToast('Publish is in progress. An email notification will be sent to you once the HTML has been published.');
          // setMLR(data?.docNumber);
          // setMlrData(data);
        }
      }
    );
  }
  const submitHTML = () => {
    setLoading(true);
    PublishHTMLAndPDFBinder(deckData.id, (response, err, errorCode) => {
      if(err?.code === "ERR_NETWORK") {
        showErrorToast('Network not found. Pl reconnect to continue');
        setLoading(false);
        return;
      } else if (err) {
        showErrorToast(`No deck was found with the requested deck id`);
        setLoading(false);
      } else {
        setLoading(false);
        if(response && response.status === 200 && response.data.success === true) {
          publishHtml(deckData?.id);
        }
      }
    });
  }

  const previewSwitchHandler = (tabList) => {
    setActiveTab(tabList);
  }

  const getCount = (index) => {
    const output = previewData?.slides?.flatMap(slide => {
      const result = [slide.index];
      if (slide.children && slide.children.length > 0) {
        slide.children.forEach((child, idx) => {
          result.push(parseFloat(`${slide.index}.${idx + 1}`));
        });
      }
      return result;
    });
    
    const item = output?.[index];

    return (
      <p>Slide {item}</p>
    );
  };

  const generateHTML = () => {
  let htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>RSD Images PDF</title>
        <style>
          body { font-family: Arial, sans-serif; }
          .rsd-track-main {
            margin: 16px;
            border: 1px solid #DDDFDD;
            border-radius: 6px;
          }
          .rsd-track-slide-number h2 {
            margin: 0;
            font-weight: 700;
            font-family: "Nunito Sans";
            font-size: 14px;
            padding: 12px 16px;
            border-bottom: 1px solid #DDDFDD;
          }
          .rsd-track-old-text,
          .rsd-track-new-text {
            padding: 16px;
            border-bottom: 1px solid #DDDFDD;
          }
          .rsd-track-old-text span,
          .rsd-track-new-text span {
            font-weight: 600;
            font-family: Nunito Sans;
            font-size: 14px;
            color: #1E1E1E;
            padding: 3px 13px;
            border-radius: 4px;
          }
          .rsd-track-old-text span {
            background-color: #F2F3F3;
          }
          .rsd-track-new-text span {
            background-color: #FFEAB4;
          }
          .rsd-track-wrapper-image {
            display: flex;
          }
          .rsd-track-old-section,
          .rsd-track-new-section {
            max-width: 595px;
          }
          .rsd-track-old-wrapper-image,
          .rsd-track-new-wrapper-image {
            padding: 16px;
          }
          .rsd-track-old-wrapper-image {
            background-color: #F2F3F3;
          }
          .rsd-track-new-wrapper-image {
            background-color: #FFEAB4;
          }
          img {
            max-width: 100%;
            height: auto;
          }
          .track-changes-text {
            margin: 16px;
          }
          .track-changes-text h3 {
            font-family: Nunito Sans;
            font-size: 10px;
            font-weight: 400;
            color: #54565B;
            margin: 0 0 2px 0;
          }
          .track-changes-text ul {
            margin-left: 16px;
            padding: 0;
          }
          .track-changes-text li {
            font-family: Nunito Sans;
            font-size: 12px;
            font-weight: 600;
            color: #1E1E1E;
            margin-bottom: 2px;
          }
          .rsd-track-single-section {
            width: 100%;
            max-width: 100%;
          }

          /* Consistent height styling when only new image is shown */
          .rsd-track-wrapper-image.equal-height img {
            height: 100%;
            object-fit: contain;
          }
        </style>
      </head>
      <body>
        <div class="rsd-track-container">
  `;

  pdfImage.forEach((payload) => {
    htmlContent += renderSlideSection(payload, `Slide ${payload.index} ${payload?.hasOwnProperty('newSlide') ? payload.newSlide ? "( New )" : "" : ""}`);

    if (payload.popupsData?.length > 0) {
      payload.popupsData.forEach((popup) => {
        htmlContent += renderSlideSection(popup, `Popup ${popup.index} ${popup?.hasOwnProperty('newPopup') ? popup.newPopup ? "( New )" : "" : ""}`);
      });
    }
  });

  htmlContent += `</div></body></html>`;
  return htmlContent;
  };

const renderSlideSection = (data, title) => {
  // console.log(data, 'hjj')
  const hasTrackChanges = data.trackChanges !== null && data.trackChanges !== undefined;

  const textChangesList = hasTrackChanges ? data.trackChanges?.text_changes || [] : [];
  const imageChangesList = hasTrackChanges ? data.trackChanges?.image_changes || [] : [];

  const normalize = (val) => (typeof val === 'string' ? val.trim().toLowerCase() : '');

  const isTextNoChange =
    textChangesList.length === 0 ||
    normalize(textChangesList[0]) === "no changes" ||
    normalize(textChangesList[0]) === "no changes detected";

  const isImageNoChange =
    imageChangesList.length === 0 ||
    normalize(imageChangesList[0]) === "no changes" ||
    normalize(imageChangesList[0]) === "no changes detected";

  const isNoChangesDetected = !hasTrackChanges || (isTextNoChange && isImageNoChange);

  let sectionHTML = `<div class="rsd-track-main">`;

  // Slide Title
  sectionHTML += `
    <div class="rsd-track-slide-number">
      <h2>${title}</h2>
    </div>
    <div class="row rsd-track-wrapper-image ${isNoChangesDetected ? 'equal-height' : ''}">
  `;

  // ✅ CASE: No changes - Only show NEW image without OLD/NEW labels
  if (isNoChangesDetected) { // removed to resolve 2485 rsd-track-new-wrapper-image from div inside section
    sectionHTML += `
      <section class="${data?.newSlide ? "rsd-track-new-section ": ""}rsd-track-single-section">
        <div class="${data?.newSlide ? "rsd-track-new-wrapper-image": "rsd-track-old-wrapper-image"}">
          <img src="${data.thumbnailNew || data.thumbnailPopupNew}" alt="New Image" />
        </div>
      </section>
    `;
  } else {
    // ✅ CASE: Changes detected - Show OLD and NEW with labels
    sectionHTML += `
      <section class="rsd-track-old-section">
        <div class="rsd-track-old-text"><span>OLD</span></div>
        <div class="rsd-track-old-wrapper-image">
          <img src="${data.thumbnail || data.thumbnailPopup}" alt="Old Image" />
        </div>
      </section>
      <section class="rsd-track-new-section">
        <div class="rsd-track-new-text"><span>NEW</span></div>
        <div class="rsd-track-new-wrapper-image">
          <img src="${data.thumbnailNew || data.thumbnailPopupNew}" alt="New Image" />
        </div>
      </section>
    `;
  }

  sectionHTML += `</div>`; // close .row

  // Track Changes Section
  sectionHTML += `
    <div class="track-changes-text">
      <h3>Track Changes<span class="red-asterisk">*</span></h3>
      <ul>
  `;

  // Handle Text Changes
  if (data.trackChanges?.text_changes[0] === "No Changes" && data.trackChanges?.image_changes[0] === "No Changes") {
    sectionHTML += `<li><span>Text Changes: </span><span>No Changes </span></li>`;
  } else if(data.trackChanges?.text_changes[0] === "No changes detected" && data.trackChanges?.image_changes[0] === "No changes detected") {
    sectionHTML += `<li><span>Text Changes: </span><span>No changes detected</span></li>`;
  } else {
    textChangesList.forEach((change, index) => {
      if (index === 0) {
        sectionHTML += `<li><span>Text Changes: </span><span>${change}</span></li>`;
      } else {
        sectionHTML += `<li>${change}</li>`;
      }
    });
  }

  // Handle Image Changes
  if (data.trackChanges?.text_changes[0] === "No changes detected" && data.trackChanges?.image_changes[0] === "No changes detected") {
    sectionHTML += `<li><span>Image Changes: </span><span>No changes detected</span></li>`;
  } else {
    imageChangesList.forEach((change, index) => {
      if (index === 0) {
        sectionHTML += `<li><span>Image Changes: </span><span>${change}</span></li>`;
      } else {
        sectionHTML += `<li>${change}</li>`;
      }
    });
  }

  sectionHTML += `
      </ul>
    </div>
  `;

  sectionHTML += `</div>`; // close .rsd-track-main

  return sectionHTML;
};

  const getTrackChanges = () => {
    getTrackChangesDetails(deckData?.id, (response, err, errorCode) => {
      if(err) {
       console.log(err, 'err');
      } else {
        const data = response?.data?.response;
        // const normalizedData = data?.map(item => ({
        //   ...item,
        //   trackChanges: item.trackChanges === null ? null : {
        //     ...item.trackChanges,
        //     image_changes: Array.isArray(item.trackChanges.image_changes)
        //       ? item.trackChanges.image_changes
        //       : [item.trackChanges?.image_changes || ""],
        //     text_changes: Array.isArray(item.trackChanges.text_changes)
        //       ? item.trackChanges.text_changes
        //       : [item.trackChanges?.text_changes || ""],
        //   },
        //   popupsData: item.popupsData?.map(popup => ({
        //     ...popup,
        //     trackChanges: popup.trackChanges === null ? null : {
        //       ...popup.trackChanges,
        //       image_changes: Array.isArray(popup.trackChanges.image_changes)
        //         ? popup.trackChanges.image_changes
        //         : [popup.trackChanges?.image_changes || ""],
        //       text_changes: Array.isArray(popup.trackChanges.text_changes)
        //         ? popup.trackChanges.text_changes
        //         : [popup.trackChanges?.text_changes || ""],
        //     },
        //   })) || [],
        // }));
        const normalizedData = data?.map(item => ({
          ...item,
          trackChanges: {
            ...item.trackChanges,
            image_changes: Array.isArray(item?.trackChanges?.image_changes)
              ? item.trackChanges.image_changes
              : [item?.trackChanges?.image_changes || "No Changes"],
            text_changes: Array.isArray(item?.trackChanges?.text_changes)
              ? item.trackChanges.text_changes
              : [item?.trackChanges?.text_changes || "No Changes"],
          },
          popupsData: item.popupsData?.map(popup => ({
            ...popup,
            trackChanges: {
              ...popup.trackChanges,
              image_changes: Array.isArray(popup?.trackChanges?.image_changes)
                ? popup.trackChanges.image_changes
                : [popup?.trackChanges?.image_changes || "No Changes"],
              text_changes: Array.isArray(popup?.trackChanges?.text_changes)
                ? popup.trackChanges.text_changes
                : [popup?.trackChanges?.text_changes || "No Changes"],
            },
          })) || [],
        }));

        setPdfImage(normalizedData);
      }
    });
  }

  const autoResize = (el) => {
    if (el) {
      el.style.height = '18px'; // reset height
      el.style.height = el.scrollHeight + 'px'; // set to scrollHeight
    }
  };

  const edetailSteps = ['Import Module', 'Author e-Detail', 'Generate RSD', 'Publish'];
  const templateSteps = ['Author Template', 'Generate RSD', 'Publish'];

  useEffect(() => {
    Object.values(inputRefs.current).forEach(el => autoResize(el));
  });

  useEffect(() => {
    generateHTML();
  }, []);
  // console.log(generateHTML(), 'generateHTML()')
  // Handle input change
  // const handleInputChange = (e, outerIndex, type, innerIndex) => {
  //   const updated = [...pdfImage];
  //   updated[outerIndex].trackChanges[type][innerIndex] = e.target.value;
  //   setPdfImage(updated);
  // };

  const handleInputChange = (e, outerIndex, type, innerIndex, slideType, popupIndex = null) => {
    const newValue = e.target.value;
    const updated = [...pdfImage];

    if(slideType === "slide") {
      const currentValue = updated[outerIndex].trackChanges[type][innerIndex];
  
      if (newValue !== currentValue) {
        updated[outerIndex].trackChanges[type][innerIndex] = newValue;
        setPdfImage(updated);
      }
    } else {
      const popupTrackChanges = updated[outerIndex].popupsData[popupIndex].trackChanges;

      if (popupTrackChanges && popupTrackChanges[type]) {
        const currentValue = popupTrackChanges[type][innerIndex];

        if (newValue !== currentValue) {
          updated[outerIndex].popupsData[popupIndex].trackChanges[type][innerIndex] = newValue;
          setPdfImage(updated);
        }
      }
    }
  };

  const handleKeyDown = (e, outerIndex, type, currentIndex, slideType, popupIndex = null) => {
  if (e.key === "Enter") {
    e.preventDefault();
    const currentValue = e.target.value;
    const cursorPos = e.target.selectionStart;

    const before = currentValue.slice(0, cursorPos).trim();
    const after = currentValue.slice(cursorPos).trim();

    const updated = [...pdfImage];

    const isCurrentEmpty = !currentValue.trim();
    const isAfterEmpty = !after;

    // Prevent creating new li if already empty
    if (isCurrentEmpty) {
      // Refocus the same input
      setTimeout(() => {
        const refKey = slideType === "slide"
          ? `${outerIndex}-${type}-${currentIndex}`
          : `${popupIndex}-${type}-${currentIndex}`;
        
        const refObj = slideType === "slide" ? inputRefs.current : inputPopupRefs.current;
        refObj[refKey]?.focus();
      }, 0);
      return;
    }

    if (slideType === "slide") {
      const currentArray = updated[outerIndex].trackChanges[type];
      currentArray[currentIndex] = before;

      // Only add a new li if there's content after the cursor
      if (!isAfterEmpty) {
        currentArray.splice(currentIndex + 1, 0, after);
      } else {
        currentArray.splice(currentIndex + 1, 0, "");
      }

      setPdfImage(updated);

      setTimeout(() => {
        const newRefKey = `${outerIndex}-${type}-${currentIndex + 1}`;
        inputRefs.current[newRefKey]?.focus();
      }, 0);
    } else if (slideType === "popup") {
      const popupTrackChanges = updated[outerIndex]?.popupsData?.[popupIndex]?.trackChanges;

      if (popupTrackChanges && Array.isArray(popupTrackChanges[type])) {
        const currentArray = popupTrackChanges[type];
        currentArray[currentIndex] = before;

        if (!isAfterEmpty) {
          currentArray.splice(currentIndex + 1, 0, after);
        } else {
          currentArray.splice(currentIndex + 1, 0, "");
        }

        setPdfImage(updated);

        setTimeout(() => {
          const newRefKey = `${popupIndex}-${type}-${currentIndex + 1}`;
          inputPopupRefs.current[newRefKey]?.focus();
        }, 0);
      }
    }
  }
};

  // const handleKeyDown = (e, outerIndex, type, currentIndex, slideType, popupIndex = null) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     const currentValue = e.target.value;
  //     const cursorPos = e.target.selectionStart;

  //     const before = currentValue.slice(0, cursorPos).trim();
  //     const after = currentValue.slice(cursorPos).trim();

  //     const updated = [...pdfImage];

  //     if(slideType === "slide") {
  //       const currentArray = updated[outerIndex].trackChanges[type];

  //       // Replace current with first half, insert new with second half
  //       currentArray[currentIndex] = before;
  //       currentArray.splice(currentIndex + 1, 0, after);

  //       setPdfImage(updated);

  //       // Wait for DOM update, then focus the new input
  //       setTimeout(() => {
  //         const newRefKey = `${outerIndex}-${type}-${currentIndex + 1}`;
  //         inputRefs.current[newRefKey]?.focus();
  //       }, 0);
  //     } else if(slideType === "popup") {
  //         const popupTrackChanges = updated[outerIndex]?.popupsData?.[popupIndex]?.trackChanges;

  //         if (popupTrackChanges && Array.isArray(popupTrackChanges[type])) {
  //           const currentArray = popupTrackChanges[type];
  //           currentArray[currentIndex] = before;
  //           currentArray.splice(currentIndex + 1, 0, after);
  //           setPdfImage(updated);
            
  //           setTimeout(() => {
  //             const newRefKey = `${popupIndex}-${type}-${currentIndex + 1}`;
  //             inputPopupRefs.current[newRefKey]?.focus();
  //           }, 0);
  //         }
  //     }
  //   }
  // };

  // Click to start editing (optional)
  const handleClick = (index) => {
    setSelectedIndex(index);
  };

   const popUpHandleClick = (index) => {
    setPopUpSelectedIndex(index);
  };

  const validateTrackChanges = (imageList) => {
    if(imageList?.trackChanges.text_changes[0] == "No Changes" || imageList?.trackChanges.image_changes[0] == "No Changes") {
      return true;
    } else if(imageList?.trackChanges?.image_changes?.every(item => item === "") && imageList?.trackChanges?.text_changes?.every(item => item === "") ){
      return false;
    } else if(imageList?.trackChanges?.image_changes?.every(item => item === "No changes detected") && imageList?.trackChanges?.text_changes?.every(item => item === "No changes detected") ){
      return true;
    } else {
      return true;
    }
  }

  const handleBlur = (e, outerIndex, type, currentIndex, slideType, popupIndex = null) => {
  const value = e.target.value.trim();

  if (value === "") {
    const updated = [...pdfImage]; // Assuming pdfImage is your main state

    if (slideType === "slide") {
      const currentArray = updated[outerIndex].trackChanges[type];

      // Only remove if more than one item is present
      if (currentArray.length > 1) {
        currentArray.splice(currentIndex, 1);
        setPdfImage(updated);
      }
    } else if (slideType === "popup") {
      const popupTrackChanges = updated[outerIndex]?.popupsData?.[popupIndex]?.trackChanges;

      if (popupTrackChanges && Array.isArray(popupTrackChanges[type])) {
        const currentArray = popupTrackChanges[type];

        if (currentArray.length > 1) {
          currentArray.splice(currentIndex, 1);
          setPdfImage(updated);
        }
      }
    }
  }
};

return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      <div className="export-pdf-container">
        <div className="export-pdf-header-section">
          <MLRPDFHeader
            previewData={previewData}
            handleApprovedtemplateModal={handleApprovedtemplateModal}
            setOpenMLRPDF={setOpenMLRPDF}
            setExportFormats={setExportFormats}
            pdfURL={deckData.pdfURL}
            deckData={deckData}
            setMLR={setMLR}
            loading={loading}
            setLoading={setLoading}
            submitMLR={submitMLR}
            mlrData={mlrData}
            setPreviewLoading={setPreviewLoading}
            submitHTML={submitHTML}
            minorVersion={minorVersion}
          ></MLRPDFHeader>
        </div>

        <div className="export-pdf-stepper">
          {mlrData && previewData && <ModuleStepper activeStep={mlrData ? mlrData?.deckType == 1 ? 2 : 3 : 0} steps={previewData?.type === 1 ? templateSteps : edetailSteps} />}
          {/* <div className="row">
            <div className="col-md-8 offset-md-2 mt-1 mb-1">
              <div className="d-flex justify-content-between">
                <div className="section-left">
                  <div className="section-items">
                    <span>
                      {previewData?.type == 1 ? "Template Name" : "e-Detail Name"}
                    </span>
                    <p>{deckData.name}</p>
                  </div>
                  <div className="section-items">
                    <span>Product</span>
                    <p>{deckData.brand}</p>
                  </div>
                  <div className="section-items">
                    <span>Country</span>
                    <p>{deckData.country && deckData.country}</p>
                  </div>
                  <div className="section-items mlr_title">
                    <span>MLR ID</span>
                    <p>{MLR}</p>
                  </div>
                </div>
                <div className="section-right">
                  <div className="section-items">
                    <span className="section-items-title">Pages </span>
                    {pageListLength.length > pageLength ? (
                      <span className="slide-no"> {numPages}</span>
                    ) : (
                      <span className="slide-no">
                        {" "}
                        {defaultNumber}
                        {numPages}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        <div className="export-pdf-tab-container RSD-preview-tab">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first" onSelect={previewSwitchHandler}>
            <Nav variant="pills" className="flex">
              <Nav.Item className="export-pdf-rsd">
                <Nav.Link
                  eventKey="first"
                >
                  RSD Preview
                </Nav.Link>
              </Nav.Item>
              <Nav.Item className="export-pdf-track">
                <Nav.Link
                  eventKey="second"
                  style={ previewData?.veevaMetadata?.find(li => li.assetType === 1)?.docStatus?.toLowerCase() === "not submitted"
                    || mlrData?.docMinorVersion != minorVersion ? {opacity: "0.5"} : {}}
                  disabled={
                    previewData?.veevaMetadata?.find(li => li.assetType === 1)?.docStatus?.toLowerCase() === "not submitted"
                    || mlrData?.docMinorVersion != minorVersion}
                >
                  RSD preview with track changes
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="export-pdf-tab-content">
              <Tab.Pane eventKey="first">
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <div className="pdf-preview-track-disclaimer">
                  <h2>Disclaimer : </h2>
                  <h3> Track changes Summary is generated by Al and might not be fully accurate. Please review carefully</h3>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
        <div className="container-fluid tempalate-preview">
          <div className=" row pdf-Conatiner" style={activeTab === "second" ? {padding: "24px 68px"} : {paddingTop: "20px"}}>
            {activeTab === "first" && <div
              id="pdf-display"
              ref={pdfDisplay}
              // className="col-md-8 offset-md-2 mt-4 pe-0 pdfRenderContainer customScrollBar"
              className="col-md-8 offset-md-2 pe-0 pdfRenderContainer customScrollBar"
            >
              <Document
                file={deckData.pdfURL}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div className="react-pdfPage" key={`page_${index + 1}`}>
                    <div className="react-pdfPage-slide-number">
                      {getCount(index)}
                    </div>
                    <Page
                      pageNumber={index + 1}
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                      width={pdfWidth}
                    />
                    {/* {
                      <div className="pdfPageNumBlock offset-mr-2">
                        {index < pageLength ? (
                          <p>
                            {defaultNumber}
                            {index + 1}
                          </p>
                        ) : (
                          <p>{index + 1}</p>
                        )}
                      </div>
                    } */}
                  </div>
                ))}
              </Document>
              {showApprovedModal && (
                // deckData?.veevaMetadata?.length > 0 &&
                // deckData?.veevaMetadata[0]?.statusMLR ===
                //   "Approved for Production" &&
                <CustomModal
                  displayModal={showApprovedModal}
                  hideModal={() => closeApprovedTemplateModal()}
                  title={""}
                  size="sm"
                  dilogClassName="alertApprovedModal"
                  keyboard={false}
                  showApprovedModal={showApprovedModal}
                >
                  <ApprovedTemplateModal
                    closeApprovedTemplateModal={closeApprovedTemplateModal}
                    showApprovedModal={showApprovedModal}
                    handleApprovedtemplateModal={handleApprovedtemplateModal}
                    submitMLR={submitMLR}
                  />
                </CustomModal>
              )}
            </div>}
            { activeTab === "second" &&
              <div
                id="pdf-display"
                ref={pdfDisplay}
                className="pdfRenderContainer customScrollBar"
                style={{borderRadius: "0", padding: "0"}}
              >
                  {pdfImage && pdfImage?.map((imageList, index) => {
                    const showOldSlide =
                      (imageList?.trackChanges) && (imageList?.trackChanges.image_changes?.[0] !== "No Changes" || imageList?.trackChanges.image_changes?.[0] !== "No Changes") &&
                      (
                        imageList.trackChanges.image_changes?.[0] !== "No changes detected" || 
                        imageList.trackChanges.text_changes?.[0] !== "No changes detected" 
                      );
                    return  <>
                      <div style={{border: "1px solid #DDDFDD", margin: "16px"}} className="Pdf-preview-track-container">
                        <div className="Pdf-preview-track-slide">
                          <h3>Slide {imageList?.index} {imageList?.hasOwnProperty('newSlide') ? imageList.newSlide ? "( New )" : "" : ""}</h3>
                        </div>
                        <div className="row m-0">
                          {showOldSlide && (
                            <div className="col-md-6 p-0">
                              <div className="Pdf-preview-track-old-slide">
                                <span className="preview-track-old-slide">OLD</span>
                              </div>
                              <div style={{ width: "100%", padding: "16px", background: "#F2F3F3" }}>
                                <div style={{ border: "1px solid #D4D4D4", height: "100%" }}>
                                  <img
                                    src={imageList?.thumbnail}
                                    alt=""
                                    className="img-fluid"
                                    style={{ maxHeight: "100%", objectFit: "contain" }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                          <div className={showOldSlide ? "col-md-6 p-0" : "col-md-12 p-0"}>
                            {showOldSlide &&
                              (
                                <div className="Pdf-preview-track-new-slide">
                                  <span className="preview-track-new-slide">NEW</span>
                                </div>
                              )
                            }
                            <div style={{width: "100%", padding: "16px", background: showOldSlide || imageList.newSlide ? "#FFEAB4" : "#F2F3F3"}}>
                              <div style={{border: "1px solid #D4D4D4", height: "100%"}}>
                                <img src={imageList?.thumbnailNew} alt="" className="img-fluid new-image" style={{maxHeight: "100%", objectFit: "contain"}}/> 
                              </div> 
                            </div>
                          </div>
                        </div>

                        <div key={imageList.index} className="track-changes-text">
                          <h3>Track Changes <span>*</span></h3>
                            <div style={{overflowX: "hidden", overflowY: "auto", maxHeight: "72px", marginLeft: "-4px"}}>
                              <ul className="edit-rsd-track">
                                {validateTrackChanges(imageList) 
                                  ? 
                                    imageList?.trackChanges?.text_changes?.map((val, idx) => {
                                      const refKey = `${index}-text_changes-${idx}`;
                                      return (
                                        <li key={idx} className="rsd-track-text-edit" onClick={() => handleClick(imageList.index)}>
                                          <div className="d-flex" style={{marginLeft: "-4px"}}>
                                            {idx === 0 && <span style={{marginRight: "2px", minWidth: "88px", cursor: "default"}}>Text Changes: </span>}
                                            {
                                              selectedIndex === imageList?.index ? (
                                              <textarea
                                                ref={el => {inputRefs.current[refKey] = el; if (el) autoResize(el)}}
                                                // type="text"
                                                onInput={(e) => autoResize(e.target)}
                                                value={val}
                                                onChange={(e) =>
                                                  handleInputChange(e, index, "text_changes", idx, "slide")
                                                }
                                                onBlur={(e) =>
                                                  handleBlur(e, index, "text_changes", idx, "slide")
                                                }
                                                onKeyDown={(e) =>
                                                  handleKeyDown(e, index, "text_changes", idx, "slide")
                                                }
                                                className={`rsd-edit-list ${idx === 0 ? "" : "edit-list"}`}
                                              />
                                            ) : (
                                              <span style={{marginLeft: "-9px"}}>{val}</span>
                                            )
                                            }
                                          </div>
                                        </li>
                                      );
                                    })
                                  :
                                    <li><span style={{marginRight: "2px", marginLeft: "-4px", cursor: "default"}}>Text Changes: </span><span>No Changes</span></li>}

                                {validateTrackChanges(imageList) 
                                ? 
                                  imageList.trackChanges.image_changes.map((val, idx) => {
                                    const refKey = `${index}-image_changes-${idx}`;
                                    return (
                                      <li key={idx} className="rsd-track-text-edit" onClick={() => handleClick(imageList?.index)}>
                                        <div className="d-flex" style={{marginLeft: "-4px"}}>
                                          {idx === 0 && <span style={{marginRight: "4px", cursor: "default"}}>Image Changes: </span> }
                                          {
                                            selectedIndex === imageList?.index ? (
                                            <textarea
                                              ref={el => {inputRefs.current[refKey] = el; if (el) autoResize(el)}}
                                              // type="text"
                                              onInput={(e) => autoResize(e.target)}
                                              value={val}
                                              onChange={(e) =>
                                                handleInputChange(e, index, "image_changes", idx, "slide")
                                              }
                                              onKeyDown={(e) =>
                                                handleKeyDown(e, index, "image_changes", idx, "slide")
                                              }
                                              onBlur={(e) =>
                                                handleBlur(e, index, "image_changes", idx, "slide")
                                              }
                                              style={{
                                                display: 'block',
                                                width: '88%',
                                                // marginBottom: '8px',
                                                overflow: 'hidden',
                                                resize: 'none',
                                                fontFamily: 'inherit',
                                              }}
                                            />
                                          ) : (
                                            val
                                          )
                                          }
                                        </div>
                                      </li>
                                    );
                                  })
                                : 
                                  <li><span style={{marginRight: "4px", marginLeft: "-4px", cursor: "default"}}>Image Changes:</span><span>No Changes</span></li>}
                              </ul>
                            </div>
                        </div>
                      </div>
                      {imageList?.popupsData?.map((popuplist, popupIndex) => {
                         const showOldPopUp =
                          (popuplist?.trackChanges.image_changes?.[0] !== "No Changes" || popuplist?.trackChanges.image_changes?.[0] !== "No Changes") &&
                          (
                            popuplist.trackChanges.image_changes?.[0] !== "No changes detected" ||
                            popuplist.trackChanges.text_changes?.[0] !== "No changes detected"
                          );
                        return (<div style={{border: "1px solid #DDDFDD", margin: "16px"}} className="Pdf-preview-track-container">
                          <div className="Pdf-preview-track-slide">
                            <h3>Popup {popuplist?.index} {popuplist?.hasOwnProperty('newPopup') ? popuplist.newPopup ? "( New )" : "" : ""}</h3>
                          </div>
                          <div className="row m-0">
                            {showOldPopUp && (
                              <div className="col-md-6 p-0">
                                <div className="Pdf-preview-track-old-slide">
                                  <span className="preview-track-old-slide">OLD</span>
                                </div>
                                <div style={{width: "100%", padding: "16px", background: "#F2F3F3"}}>
                                  <div style={{border: "1px solid #D4D4D4", height: "100%"}}>
                                    <img src={popuplist?.thumbnailPopup} alt="" className="img-fluid" style={{maxHeight: "100%", objectFit: "contain"}}/>
                                  </div>
                                </div>
                              </div> )
                            }
                            <div className={showOldPopUp ? "col-md-6 p-0" : "col-md-12 p-0"}>
                              {showOldPopUp && (
                                <div className="Pdf-preview-track-new-slide">
                                  <span className="preview-track-new-slide">NEW</span>
                                </div>)
                              }
                              <div style={{width: "100%", padding: "16px", background: "#FFEAB4"}}>
                                <div style={{border: "1px solid #D4D4D4", height: "100%"}}>
                                  <img src={popuplist?.thumbnailPopupNew} alt="" className="img-fluid" style={{maxHeight: "100%", objectFit: "contain"}}/> 
                                </div> 
                              </div>
                            </div>
                          </div>
                          <div key={popuplist?.index} className="track-changes-text">
                            <h3>Track Changes <span>*</span></h3>
                            <div style={{overflowX: "hidden", overflowY: "auto", maxHeight: "72px", marginLeft: "-4px"}}>
                              <ul className="edit-rsd-track">
                                {popuplist?.trackChanges !== null ? popuplist?.trackChanges?.text_changes?.map((c, i) => {
                                      const refKey = `${popupIndex}-text_changes-${i}`;
                                  return <li key={i} className="rsd-track-text-edit" onClick={() => popUpHandleClick(popuplist?.index)}>
                                            <div className="d-flex" style={{marginLeft: "-4px"}}>
                                              {i === 0 && <span style={{marginRight: "2px", minWidth: "88px", cursor: "default"}}>Text Changes: </span>}
                                              {popupSelectedIndex === popuplist.index ? (
                                                  <textarea
                                                    ref={el => {inputPopupRefs.current[refKey] = el; if (el) autoResize(el)}}
                                                    // type="text"
                                                    onInput={(e) => autoResize(e.target)}
                                                    value={c}
                                                    onChange={(e) =>
                                                      handleInputChange(e, index, "text_changes", i, 'popup', popupIndex)
                                                    }
                                                    onKeyDown={(e) =>
                                                      handleKeyDown(e, index, "text_changes", i, 'popup', popupIndex)
                                                    }
                                                    onBlur={(e) =>
                                                      handleBlur(e, index, "text_changes", i, 'popup', popupIndex)
                                                    }
                                                    className={`rsd-edit-list ${i === 0 ? "" : "edit-list"}`}
                                                  />
                                                ) : (
                                                  <span style={{marginLeft: "-9px"}}>{c}</span>
                                                )}
                                              {/* {(popuplist?.trackChanges?.text_changes?.every(item => item === "No changes detected")) ? <span style={{marginLeft: "-9px"}}>{c}</span> 
                                                : popupSelectedIndex === popuplist.index ? (
                                                  <textarea
                                                    ref={el => {inputPopupRefs.current[refKey] = el; if (el) autoResize(el)}}
                                                    // type="text"
                                                    onInput={(e) => autoResize(e.target)}
                                                    value={c}
                                                    onChange={(e) =>
                                                      handleInputChange(e, index, "text_changes", i, 'popup', popupIndex)
                                                    }
                                                    onKeyDown={(e) =>
                                                      handleKeyDown(e, index, "text_changes", i, 'popup', popupIndex)
                                                    }
                                                    className={`rsd-edit-list ${i === 0 ? "" : "edit-list"}`}
                                                  />
                                                ) : (
                                                  <span style={{marginLeft: "-9px"}}>{c}</span>
                                                )} */}
                                            </div>
                                          </li>
                                })
                                : <li><span style={{marginRight: "2px", marginLeft: "-4px", cursor: "default"}}>Text Changes: </span><span>No Changes</span></li>
                                }
                                {popuplist?.trackChanges !== null ? popuplist?.trackChanges?.image_changes?.map((c, i) => {
                                    const refKey = `${popupIndex}-image_changes-${i}`;
                                  return <li key={i} className="rsd-track-text-edit" onClick={() => popUpHandleClick(popuplist?.index)}>
                                            <div className="d-flex" style={{marginLeft: "-4px"}}>
                                              {i === 0 && <span style={{marginRight: "2px", minWidth: "88px", cursor: "default"}}>Image Changes: </span>}
                                              {popupSelectedIndex === popuplist?.index ? (
                                                <textarea
                                                  ref={el => {inputPopupRefs.current[refKey] = el; if (el) autoResize(el)}}
                                                  // type="text"
                                                  onInput={(e) => autoResize(e.target)}
                                                  value={c}
                                                  onChange={(e) =>
                                                    handleInputChange(e, index, "image_changes", i, "popup", popupIndex)
                                                  }
                                                  onKeyDown={(e) =>
                                                    handleKeyDown(e, index, "image_changes", i, "popup", popupIndex)
                                                  }
                                                  onBlur={(e) =>
                                                    handleBlur(e, index, "image_changes", i, "popup", popupIndex)
                                                  }
                                                  style={{
                                                    display: 'block',
                                                    width: '88%',
                                                    // marginBottom: '8px',
                                                    overflow: 'hidden',
                                                    resize: 'none',
                                                    fontFamily: 'inherit',
                                                  }}
                                                />
                                              ) : (
                                                c
                                              )}
                                              {/* {(popuplist?.trackChanges?.image_changes?.every(item => item === "No changes detected")) ? <span>{c}</span> 
                                                : popupSelectedIndex === popuplist?.index ? (
                                                <textarea
                                                  ref={el => {inputPopupRefs.current[refKey] = el; if (el) autoResize(el)}}
                                                  // type="text"
                                                  onInput={(e) => autoResize(e.target)}
                                                  value={c}
                                                  onChange={(e) =>
                                                    handleInputChange(e, index, "image_changes", i, "popup", popupIndex)
                                                  }
                                                  onKeyDown={(e) =>
                                                    handleKeyDown(e, index, "image_changes", i, "popup", popupIndex)
                                                  }
                                                  style={{
                                                    display: 'block',
                                                    width: '88%',
                                                    // marginBottom: '8px',
                                                    overflow: 'hidden',
                                                    resize: 'none',
                                                    fontFamily: 'inherit',
                                                  }}
                                                />
                                              ) : (
                                                c
                                              )} */}
                                            </div>
                                          </li>
                                }) : <li><span style={{marginRight: "2px", marginLeft: "-4px", cursor: "default"}}>Image Changes: </span><span>No Changes</span></li>}
                              </ul>
                            </div>
                          </div>
                        </div>)
                      })}
                    </>
                  })}
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}
